import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl, toBool } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import CustomCheckBoxWithProps from '../../components/checkBox/customCheckBox';
import { useSelector } from 'react-redux';
import CustomPressable from '../../components/customPressable/customPressable';
import { HEART } from '../../assets';
import { formatMinutesToTimeFormat } from '../../js/formatTime';

const SpaBooking2b = (props) => {
    const { currentWidget, bookingObj, updateBookingObj, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();

    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice);
    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;

    const getAllTechnician = () => {
        const availableTechnician = [];

        bookingObj?.technicianAvailableData?.forEach((data) => {
            const dateAvailable_ = data.availableDate.split('T')[0];
            const startTime = data.startTime;
            data.results.forEach((d) => {
                availableTechnician.push({
                    technicianId: d.technicianId,
                    technicianName: d.technicianName || (d.technician && d.technician.fullNameDisplayed) || `${d.technician.firstName ? d.technician.firstName : ''} ${d.technician.lastName ? d.technician.lastName : ''}`,
                    availableDate: dateAvailable_,
                    startTime: startTime,
                    technicianPrice: d.technician.price
                });
            });
        });
        return availableTechnician;
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'spaBookingRootContainer'])} id='spaBookingRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'spaBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='spaBookingMainContainer'
            >
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'spaBookingHeaderContainer'])} id='spaBookingHeaderContainer'>
                    {
                    currentWidget?.widgetHeaderImageUrl && 
                        <ImageComp
                            source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                            style={getStyles(['widgetmainContainerHeaderImg', 'spaBookingHeaderImg'])} id={"spaBookingHeaderImg"}
                        />
                    }
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'spaBookingHeaderTitleContainer'])} id='spaBookingHeaderTitleContainer'>
                        <ImageComp source={HEART} style={getStyles(["spaBookingHeaderTitleImage"])} id="spaBookingHeaderTitleImage"/>

                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'spaBookingHeaderTitle'])} id='spaBookingHeaderTitle'>
                            {t(`spaBooking.availability.heading`)}
                        </Text>

                        <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'spaBookingHeaderSubTitle'])} id='spaBookingHeaderSubTitle'>
                            {t("spaBooking.availability.subheading")}
                        </Text>
                        <View style={getStyles(["horizontalline"])} id='horizontalline'></View>
                    </View>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'spaBookingMainContainerChildContainer'])} id='spaBookingMainContainerChildContainer'>
                    <View style={getStyles(["spaBookingTechnicalDataContainer"])} id='spaBookingTechnicalDataContainer'>
                        <Text style={getStyles(["spaBookingTechnicalDataTitle"])} id='spaBookingTechnicalDataTitle'>{t(`spaBooking.available_time`)}</Text>

                        <View style={getStyles(["spaBookingTechnicalDataListContainer"])} id='spaBookingTechnicalDataListContainer'>
                            {bookingObj?.technicianAvailableData && getAllTechnician()
                                .map((technician) => {
                                    return (

                                        <CustomPressable onPress={() => updateBookingObj({selectedTechnicianDetails: technician})} style={getStyles(["list_itemContainer", "spaBookingTechnicalDataListItemContainer"])} id='spaBookingTechnicalDataListItemContainer'>
                                            <CustomCheckBoxWithProps
                                                // type="radio"
                                                checkBoxStyle={getStyles(["spaBooking1aOnlineListItemCheckbox"])}
                                                id="spaBooking1aOnlineListItemCheckbox"
                                                value={JSON.stringify(bookingObj?.selectedTechnicianDetails) == JSON.stringify(technician)}
                                                onValueChange={() => {}}
                                            />

                                            <Text style={getStyles(["spaBookingTechnicalDataListItemStartime"])} id='spaBookingTechnicalDataListItemStartime'>
                                                {` ${formatMinutesToTimeFormat(technician.startTime, toBool(TIME_FORMAT))}`}
                                                <Text style={getStyles(["spaBookingTechnicalDataListItemTechnicianName"])} id='spaBookingTechnicalDataListItemTechnicianName'>-{technician.technicianName}</Text>
                                            </Text>
                                        </CustomPressable>
                                    );
                            })}
                        </View>
                    </View>

                </View>

            
            </ScrollView>

            <View id='spaBookingNextButtonContainer' style={getStyles(['spaBookingNextButtonContainer'])}>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={() => handleNext(bookingObj?.selectedTechnicianDetails)} id="primaryBtn" disabled={!bookingObj?.selectedTechnicianDetails}>
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t("spaBooking.continue")}
                    </Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>{t('spaBooking.back')}</Text>
                </CustomPressable> */}
            </View>


        </View>
    )
}

export default SpaBooking2b
